import { Editor } from '@tiptap/react'
import { createContext, useContext } from 'react'

type Context = {
  editor: Editor | null
  isToolbarTopActive: boolean
  isEditorFocused: boolean
  getTextValue: () => string
}

export const TextEditorContext = createContext<Context | null>(null)

export const useTextEditorContext = () => {
  const context = useContext(TextEditorContext)

  if (!context) {
    throw new Error('useTextEditor must be used within a TextEditorProvider')
  }
  return context
}
